import {defaultFilter, defaultPayload, defaultItemPayload} from "@/servicios/general_monitoring/state";

/**
 * Cargar información
 *
 */
export function setDataGeneralMonitoring(state, data) {
    state.general_monitorings = data;
}


/**
 * Generar informacion para crear data en el módulo de seguimiento.
 *
 */
export function setDatapayload(state, response) {
    if (response.data.length) {
        state.findings = response;
        state.company = response.data[0].company ? response.data[0].company.nombre : null;
        state.location = (response.data[0].check_list && response.data[0].check_list.location) ? response.data[0].check_list.location.description : '';
        state.findings.data = response.data.map(item => {
            let status = 'Creado';

            if(item.state == 'ABIERTO') {
                status = 'Creado';
            } else if (item.state == 'PROGRESO') {
                status = 'Ejecución';
            } else if (item.state == 'CERRADO'){
                status = 'Cerrado'
            }


            return {
                module_id: item.id,
                company_id: state.filter.company_id,
                slq_location_id: state.filter.slq_location_id,
                source_module: state.filter.source_module,
                description: item.observaciones,
                sys_user_id: item.responsable,
                concept: '',
                legislation: item.legislacion,
                improvement_options: item.opciones_mejora,
                implement_percentage: item.porcentaje_implementacion,
                files: [],
                status,
                wor_worker_id :item.wor_worker_id
            }
        })
    } else {
        state.findings.data = [];
    }
}

/**
 * Limpiar filtro
 *
 */
export function clearFilter(state) {
    state.filter = defaultFilter();
    state.general_monitorings = [];
}


/**
 * Limpiar filtro
 */
export function setGrmDetail(state, grmDetail) {
    state.grmDetail = grmDetail;
}


/**
 * Limpiar payload.
 */
export function clearPayload(state) {
    state.payload = defaultPayload();
}

/**
 * Eliminar registro de archivo inactivado
 */
export function addItemPayload(state) {
    state.payload.push(defaultItemPayload());
}


/**
 * Eliminar registro de archivo inactivado
 */
export function deleteItemPayload(state, index) {
    state.payload.splice(index, 1);
}


/**
 * Eliminar registro eliminado del array.
 */
export function deleteItemGeneralMonitorings(state, id) {
    const index = state.general_monitorings.data.findIndex(item => item.id === id);
    state.general_monitorings.data.splice(index, 1);
}


/**
 * Setear si es un reporte o no
 *
 */
export function setIsReport(state, condition) {
    state.filter.is_report = condition
}


/**
 * Actualizar la cantidad de items a mostrar en la tabla.
 *
 */
export function updatePerPage(state, per_page) {
    state.filter.per_page = per_page
}



/**
 * Agregar informacion para graficas
 *
 * @param data
 */
export async function setInfoCharts(state, data) {
    state.grm_chart = data;
}
